import { DateTime } from "luxon"
import { Text } from "@oysterhr/ui"
import { BenefitsEnrollment, BenefitsEnrollmentStateEnum } from "@oysterhr/schema"

const {
  Enrolled,
  Applied,
  Finished,
  Cancelled,
  InProgress,
  AwaitingToBeFinished,
  ModifiedEnrollment,
} = BenefitsEnrollmentStateEnum
const VALID_STATES = new Set([
  Enrolled,
  Applied,
  Finished,
  InProgress,
  AwaitingToBeFinished,
  ModifiedEnrollment,
])

const dateLike1Jan2000 = (isoDate: string): string => {
  return DateTime.fromISO(isoDate).toLocaleString({
    day: "numeric",
    month: "short",
    year: "numeric",
  })
}

const DateInterval = ({ startDate, endDate }: { startDate: string; endDate?: string }) => {
  return (
    <>
      {dateLike1Jan2000(startDate)}
      {endDate && <Text size="tiny">{` - ${dateLike1Jan2000(endDate)}`}</Text>}
    </>
  )
}

export const CoverageDate = ({ benefitEnrollment }: { benefitEnrollment: BenefitsEnrollment }) => {
  const { state, coverageStartDate, coverageEndDate } = benefitEnrollment
  if (state === Cancelled) return <>{"n/a"}</>

  const validCoverageDate = VALID_STATES.has(benefitEnrollment?.state) && coverageStartDate

  if (!validCoverageDate) return <>{"-"}</>
  return <DateInterval startDate={coverageStartDate} endDate={coverageEndDate} />
}
